import React from "react";
import { Link } from "gatsby";
import { GatsbyImage, StaticImage } from "gatsby-plugin-image";

const Logo = ({ logo }) => {
  return (
    <div className="relative block -mt-[60px] md:-mt-20 bg-white/0 overflow-visible box-border z-[1] text-center">
      <Link to="/">
        {!logo ? (
          <GatsbyImage image={logo?.asset?.gatsbyImageData} alt={logo?.alt} />
        ) : (
          <StaticImage
            src={"../../../images/logo.png"}
            alt="Logo"
            className="max-w-full h-auto mx-auto"
            height={140}
          />
        )}
      </Link>
    </div>
  );
};

export default Logo;
